<fc-search-input
  [label]="'FC_EQUIPMENT_TYPE.LABEL' | translate"
  [control]="control"
  [search]="search"
  [displayWith]="displayWith"
  [showSearchIcon]="showSearchIcon"
  [requiredMark]="requiredMark"
  [preloadOptions]="preloadOptions"
  [searchOnFocus]="searchOnFocus"
  [translateErrorPrefix]="translateErrorPrefix"
  [enableInfiniteScroll]="enableInfiniteScroll"
></fc-search-input>
